import { BRAND_NAME } from "./_variable";

const configMap = {
    staging: {
        brandName: "excotrades",
        // backendURL: "https://adminapi.antospnc.app/",
        // graphqlURL: "https://adminapi.antospnc.app/graphql",
        backendURL: "https://admin.worthycodes.com/",
        commissionURL: "https://commission.worthycodes.app/",
        graphqlURL: "https://admin.worthycodes.com/graphql",
        // backendURL: "http://localhost:41960/",
        // graphqlURL: "http://localhost:41960/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        defaultLayout: 2,
        mode: "development",
    },
    fundamarkets: {
        brandName: "fundamarkets",
        backendURL: "https://admin.fundamarkets.app/",
        commissionURL: "https://commission.fundamarkets.app/",
        graphqlURL: "https://admin-web.fundamarkets.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        defaultLayout: 6,
        mode: "development",
    },
    excotrades: {
        brandName: "excotrades",
        backendURL: "https://admin.excotrades.app/",
        commissionURL: "https://commission.excotrades.app/",
        graphqlURL: "https://admin-web.excotrades.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        defaultLayout: 2,
        mode: "development",
    },
    metapromarkets: {
        brandName: "metapromarkets",
        backendURL: "https://admin.metapromarkets.app/",
        commissionURL: "https://commission.metapromarkets.app/",
        graphqlURL: "https://admin-web.metapromarkets.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        defaultLayout: 3,
        mode: "development",
    },
    ridgewaymarkets: {
        brandName: "ridgewaymarkets",
        backendURL: "https://admin.ridgewaymarkets.app/",
        commissionURL: "https://commission.ridgewaymarkets.app/",
        graphqlURL: "https://admin-web.ridgewaymarkets.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        defaultLayout: 4,
        mode: "development",
    },
    alliumtrades: {
        brandName: "alliumtrades",
        backendURL: "https://admin.alliumtrades.app/",
        commissionURL: "https://commission.alliumtrades.app/",
        graphqlURL: "https://admin-web.alliumtrades.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        defaultLayout: 6,
        mode: "development",
    },
    minosmarkets: {
        brandName: "minosmarkets",
        backendURL: "https://admin.minosmarkets.app/",
        commissionURL: "https://commission.minosmarkets.app/",
        graphqlURL: "https://admin-web.minosmarkets.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        cmsURL: "minosbrokers.com",
        defaultLayout: 5,
        mode: "development",
    },
    cronoscap: {
        brandName: "cronoscap",
        backendURL: "https://admin.cronoscap.app/",
        commissionURL: "https://commission.cronoscap.app/",
        graphqlURL: "https://admin-web.cronoscap.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        cmsURL: "cronoscap.com",
        defaultLayout: 5,
        mode: "development",
    },
    quorvex: {
        brandName: "quorvex",
        backendURL: "https://admin.qvmarkets.app/",
        commissionURL: "https://commission.qvmarkets.app/",
        graphqlURL: "https://admin.qvmarkets.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        assetsURL: "https://assets.nextrades.ai",
        assetsBrandName: "qvmarkets",
        verificationURL: "https://verification.qvmarkets.app",
        questionnaireURL: "https://questionnaire.qvmarkets.app",
        strategyBuilderURL: "https://strategybuilder.nextrades.ai",
        defaultLayout: 3,
        mode: "development",
    },
    blueocean: {
        brandName: "blueocean",
        backendURL: "https://admin.blueoceanfin.app/",
        commissionURL: "https://commission.blueoceanfin.app/",
        graphqlURL: "https://admin.blueoceanfin.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        tradeURL: "https://mt5.nextrades.ai/api",
        assetsURL: "https://assets.nextrades.ai",
        verificationURL: "https://verification.blueoceanfin.app",
        strategyBuilderURL: "https://strategybuilder.nextrades.ai",
        questionnaireURL: "https://questionnaire.blueoceanfin.app",
        assetsBrandName: "blueocean",
        defaultLayout: 1,
        mode: "development",
    },
    antos: {
        brandName: "antos",
        backendURL: "https://admin-old.antospnc.app/",
        commissionURL: "https://commission.antospnc.app/",
        graphqlURL: "https://admin-web-old.antospnc.app/graphql",
        // backendURL: "https://admin.worthycodes.com/",
        // graphqlURL: "https://admin-web.worthycodes.com/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        tradeURL: "https://mt5.antospnc.app/api",
        mt5WebSocket: "wss://xsocket.antospnc.app",
        defaultLayout: 2,
        mode: "development",
    },
    antospnc: {
        brandName: "antos",
        backendURL: "https://admin.antospnc.app/",
        commissionURL: "https://commission.antospnc.app/",
        graphqlURL: "https://admin.antospnc.app/graphql",
        // backendURL: "https://admin.worthycodes.com/",
        // graphqlURL: "https://admin-web.worthycodes.com/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        tradeURL: "https://mt5.antospnc.app/api",
        assetsURL: "https://assets.nextrades.ai",
        assetsBrandName: "antospnc",
        verificationURL: "https://verification.antospnc.app",
        questionnaireURL: "https://questionnaire.antospnc.app",
        strategyBuilderURL: "https://strategybuilder.nextrades.ai",
        mt5WebSocket: "wss://xsocket.antospnc.app",
        defaultLayout: 2,
        mode: "development",
    },
    dearc: {
        brandName: "dearc",
        backendURL: "https://admin.dearc.app/",
        commissionURL: "https://commission.dearc.app/",
        graphqlURL: "https://admin.dearc.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        tradeURL: "https://mt5.nextrades.ai/api",
        defaultLayout: 5,
        mode: "development",
    },
    pxmarkets: {
        brandName: "pxmarkets",
        backendURL: "https://admin.pxmarkets.app/",
        commissionURL: "https://commission.pxmarkets.app/",
        graphqlURL: "https://admin.pxmarkets.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        assetsURL: "https://assets.nextrades.ai",
        assetsBrandName: "pxmarkets",
        verificationURL: "https://verification.pxmarkets.app",
        questionnaireURL: "https://questionnaire.pxmarkets.app",
        strategyBuilderURL: "https://strategybuilder.nextrades.ai",
        defaultLayout: 3,
        mode: "development",
    },
    // Add more configuration mappings for different names
};

function getConfigByName() {
    const config = configMap[BRAND_NAME];
    if (config) {
        return config;
    } else {
        // Return a default configuration or handle the case when the name is not found
        return null;
    }
}

export default getConfigByName;
